import { Avatar, Box, Grid, Stack, styled, Typography } from "@mui/material";
import React from "react";
import { allIcons } from "../../../assets";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1200px",
  margin: "auto",
  padding: "16px",

  "& .lpl_best_pr": {
    fontWeight: 700,
    fontSize: "2rem",
    textAlign: "center",
    marginBottom: "4rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      //   textAlign: "left",
    },
  },

  "& .lpl_best_gr": {
    fontWeight: 700,
    fontSize: "2.5rem",
    background: "linear-gradient(90deg, #EA580C 0%, #000000 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },

  "& .lpl_bcard_con": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  "& .lpl_bcard_image": {
    height: 100,
    width: 100,
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
    padding: 25,
  },
  "& .lpl_bcard_title": {
    fontWeight: 700,
    fontSize: "1.5rem",
    position: "relative",
    display: "inline-block",
    paddingBottom: "10px",
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: "5px",
      backgroundImage: "linear-gradient(90deg, #EA580C 0%, #000000 100%)",
    },
  },
}));

let renderData = [
  {
    icon: allIcons.microphoneIcon,
    title: "Support",
    description:
      "We offer a 7-days free trial for new members to try the salon booking system! Our team is always here to help you 24/7. Your success and experience with using our beauty salon scheduling software matters to us.",
  },
  {
    icon: allIcons.mobilephoneIcon,
    title: "Easy Access",
    description:
      "You can access your online salon booking system panel via our mobile app or website. Salon management software makes online booking and scheduling easy.",
  },
  {
    icon: allIcons.hourIcon,
    title: "Convenience",
    description:
      "Follow up on client history, financial records, customer visits, and staff profiles all from your web and mobile phone. Receive notifications directly to your smartphone.",
  },
];

function BestFor() {
  const renderCards = (data) => {
    return (
      <Grid container spacing={{ sm: 4 }} justifyContent={"center"}>
        {data?.map((val, index) => {
          return (
            <Grid
              key={index}
              item
              xs={12}
              sm={6}
              md={4}
              className={"lpl_bcard_con"}
            >
              <Avatar src={val.icon} className="lpl_bcard_image" />
              <Typography my={2} variant={"h1"} className="lpl_bcard_title">
                {val.title}
              </Typography>
              <Typography my={2} variant={"body1"} color={"#747677"} p={2}>
                {val.description}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Typography variant="h1" className="lpl_best_pr">
        Working In A Way That Works{" "}
        <span className="lpl_best_gr"> Best For You</span>
      </Typography>

      {renderCards(renderData)}
    </MainView>
  );
}

export default BestFor;
